import color from 'styles/scss/_theme.module.scss';

const theme = {
    color,

    // headerheight and footerHeight is not for setting it's height, but relationally setting content heights
    headerHeight: '75px',
    footerHeightMD: '120px',
    footerHeightLG: '120px',
    modalBackgroundTop: '0',
    stickyTop: '0',
    navPaddingTopBottom: '0.25rem',
    transitionTime: '0.15s',

    borderRadius: '3px',
    radiusSm: '3px',
    radiusMd: '7px',
    radiusLg: '10px',

    defaultSpacing: '15px',

    baseLineHeight: '1.25rem',

    fontCondensed: 'Roboto Condensed, sans-serif',
    fontSerif: 'Georgia, serif',
};

export default theme;
